import script from "./AgentToggleRow.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentToggleRow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import NeueToggle from "@/components/neue/NeueToggle.vue";
script.components = Object.assign({}, { NeueToggle }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { NeueToggle }, script.__o.components);}